/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 7th 2022, 8:06:11 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { Info as InfoIcon } from "react-feather";
import { Image, EmphasisText, Typography, GeneralHelpDialogWrapper } from "ui-widgets";

export const EmailServerTipButton = () => (
  <GeneralHelpDialogWrapper
    helpTooltipText={<Typography> Mail Server Configuration tip</Typography>}
    helpButtonIcon={<InfoIcon />}
    helpTitle={<>Tip: Mail Server Configuration</>}
    helpContent={
      <>
        All email notifications will be sent out from a <EmphasisText>onestop.site</EmphasisText> email unless you add
        your own email server configuration for your portal(s).
      </>
    }
    helpIllustration={<Image src="/img/email-server.png" />}
  />
);
